"use strict";
var _a, _b;
exports.__esModule = true;
exports.SubunitPermissionTargetTypes = exports.DepartmentPermissionTargetTypes = exports.DepartmentPermissionTarget = exports.PermissionType = exports.UserProfileType = void 0;
var UserProfileType;
(function (UserProfileType) {
    UserProfileType["ApiKey"] = "api_key";
    UserProfileType["Admin"] = "admin";
    UserProfileType["Staff"] = "staff";
    UserProfileType["Student"] = "student";
    UserProfileType["Others"] = "others";
})(UserProfileType = exports.UserProfileType || (exports.UserProfileType = {}));
var PermissionType;
(function (PermissionType) {
    PermissionType["View"] = "view";
    PermissionType["Add"] = "add";
    PermissionType["Edit"] = "edit";
    PermissionType["Delete"] = "delete";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
var DepartmentPermissionTarget;
(function (DepartmentPermissionTarget) {
    DepartmentPermissionTarget["DocumentsListView"] = "documents.list_view";
    DepartmentPermissionTarget["DocumentsDetailView"] = "documents.detail_view";
    DepartmentPermissionTarget["Activities"] = "activities";
    DepartmentPermissionTarget["Tasks"] = "tasks";
    DepartmentPermissionTarget["TasksAccessOthers"] = "tasks.access_others";
    DepartmentPermissionTarget["TasksReassign"] = "tasks.reassign";
    DepartmentPermissionTarget["TasksReopenCompleted"] = "tasks.reopen_completed";
    DepartmentPermissionTarget["Chat"] = "chat";
    DepartmentPermissionTarget["Director"] = "director";
    DepartmentPermissionTarget["OtherUsersCalendars"] = "other_users_calendars";
    DepartmentPermissionTarget["OtherUsersChats"] = "other_users_chats";
})(DepartmentPermissionTarget = exports.DepartmentPermissionTarget || (exports.DepartmentPermissionTarget = {}));
exports.DepartmentPermissionTargetTypes = (_a = {},
    _a[DepartmentPermissionTarget.Chat] = [PermissionType.View, PermissionType.Add],
    _a[DepartmentPermissionTarget.OtherUsersCalendars] = [
        PermissionType.View,
        PermissionType.Add,
        PermissionType.Edit,
        PermissionType.Delete,
    ],
    _a[DepartmentPermissionTarget.OtherUsersChats] = [
        PermissionType.View,
        PermissionType.Delete,
    ],
    _a);
exports.SubunitPermissionTargetTypes = (_b = {},
    _b[DepartmentPermissionTarget.DocumentsListView] = [PermissionType.View],
    _b[DepartmentPermissionTarget.DocumentsDetailView] = [
        PermissionType.View,
        PermissionType.Add,
        PermissionType.Edit,
        PermissionType.Delete,
    ],
    _b[DepartmentPermissionTarget.Activities] = [
        PermissionType.View,
        PermissionType.Add,
        PermissionType.Edit,
        PermissionType.Delete,
    ],
    _b[DepartmentPermissionTarget.Tasks] = [
        PermissionType.View,
        PermissionType.Add,
        PermissionType.Edit,
        PermissionType.Delete,
    ],
    _b[DepartmentPermissionTarget.TasksAccessOthers] = [
        PermissionType.View,
        PermissionType.Edit,
        PermissionType.Delete,
    ],
    _b[DepartmentPermissionTarget.TasksReassign] = [PermissionType.Edit],
    _b[DepartmentPermissionTarget.TasksReopenCompleted] = [PermissionType.Edit],
    _b[DepartmentPermissionTarget.Director] = [
        PermissionType.View,
        PermissionType.Edit,
        PermissionType.Delete,
    ],
    _b);
